import { Moment } from "moment/moment"

export const weekdayAccusativeMap: Record<string, string> = {
  pondělí: "Každé pondělí",
  úterý: "Každé úterý",
  středa: "Každou středu",
  čtvrtek: "Každý čtvrtek",
  pátek: "Každý pátek",
  sobota: "Každou sobotu",
  neděle: "Každou neděli"
}
// Mapování symbolů dnů v týdnu na klíče pro weekdayAccusativeMap
export const daySymbolToAccusativeKey: Record<string, string> = {
  monday: "pondělí",
  tuesday: "úterý",
  wednesday: "středa",
  thursday: "čtvrtek",
  friday: "pátek",
  saturday: "sobota",
  sunday: "neděle"
}
const weekdayGenitiveMap: Record<string, string> = {
  pondělí: "pondělí",
  úterý: "úterý",
  středa: "středy",
  čtvrtek: "čtvrtka",
  pátek: "pátku",
  sobota: "soboty",
  neděle: "neděle"
}
const weekdayLocativeMap: Record<string, string> = {
  pondělí: "v pondělí",
  úterý: "v úterý",
  středa: "ve středu",
  čtvrtek: "ve čtvrtek",
  pátek: "v pátek",
  sobota: "v sobotu",
  neděle: "v neděli"
}
export const getLocalizedWeekday = (date: Moment): string => {
  const weekday = date.format("dddd")
  return weekdayAccusativeMap[weekday] || weekday
}
export const getWeekdayLocative = (date: Moment): string => {
  const weekday = date.format("dddd")
  return weekdayLocativeMap[weekday] || `v ${weekday}`
}
export const getWeekdayGenitive = (date: Moment): string => {
  const weekday = date.format("dddd")
  return weekdayGenitiveMap[weekday] || weekday
}
